import { useSetAtom } from 'jotai'
import { type FC } from 'react'

import { rightContentPortalElementAtom } from '../../-states'

/**
 * コンテンツエリアの右側部分のコンポーネント
 * - RightContentPortal を指定して任意の表示内容を追加
 */
export const RightContentWrapper: FC = () => {
  const setRightContentPortalElement = useSetAtom(rightContentPortalElementAtom)

  return <div ref={setRightContentPortalElement} />
}
